var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#021F36"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2237_8602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5862 10H15.4138C12.4286 10 10 12.4286 10 15.4138V24.5863C10 27.5714 12.4286 30 15.4138 30H24.5863C27.5714 30 30 27.5714 30 24.5863V15.4138C30 12.4286 27.5714 10 24.5862 10V10ZM20 25.4686C16.9845 25.4686 14.5314 23.0154 14.5314 20C14.5314 16.9845 16.9845 14.5314 20 14.5314C23.0154 14.5314 25.4686 16.9845 25.4686 20C25.4686 23.0154 23.0154 25.4686 20 25.4686ZM25.5993 15.8211C24.7082 15.8211 23.9834 15.0963 23.9834 14.2052C23.9834 13.314 24.7082 12.5891 25.5993 12.5891C26.4904 12.5891 27.2154 13.314 27.2154 14.2052C27.2154 15.0963 26.4904 15.8211 25.5993 15.8211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 15.7141C17.637 15.7141 15.7144 17.6366 15.7144 19.9998C15.7144 22.3629 17.637 24.2855 20.0001 24.2855C22.3633 24.2855 24.2858 22.3629 24.2858 19.9998C24.2858 17.6366 22.3633 15.7141 20.0001 15.7141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5994 13.7617C25.355 13.7617 25.156 13.9607 25.156 14.2051C25.156 14.4496 25.355 14.6486 25.5994 14.6486C25.844 14.6486 26.043 14.4497 26.043 14.2051C26.043 13.9605 25.844 13.7617 25.5994 13.7617Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2237_8602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgSocialMedia);
export default __webpack_public_path__ + "static/media/IGSocialMedia.cb920c07c2047398fc6039694b9e315b.svg";
export { ForwardRef as ReactComponent };